import styled from 'styled-components'

const HeadlineWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

export { HeadlineWrap }
